import React from 'react'
import { connect } from 'react-redux'

class Terms extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    const { terms } = this.props

    return (
      <div>
        <div className='settings-units-container' style={{
          height: 'calc(100vh - 171px)',
          width: 360,
          overflowY: 'auto',
          overflowX: 'hidden',
          fontSize: '12px'
        }}>
          {terms.text.split('\n').map(str => {
            return (<p style={{ marginTop: '10px', fontStyle: 'Roboto, sans-serif' }}>{str}</p>)
          })}
        </div>
      </div>
    )
  }
}


const mapStateToProps = state => ({
  terms: state.terms
})

const mapDispatchToProps = dispatch => ({
})

export default connect(mapStateToProps, mapDispatchToProps)(Terms)